import { Button, Flex, Spacer } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { SetterOrUpdater } from "recoil";
import { Step } from "../models/steps";
import FixFontShift from "./FixFontShift";

export interface StepperActionsProps {
  nextStep?: Step;
  prevStep?: Step;
  setStep: SetterOrUpdater<Step>;
}

const StepperActions: React.FC<StepperActionsProps> = ({
  nextStep,
  prevStep,
  setStep,
}) => {
  const { t } = useTranslation();

  return (
    <Flex>
      {/* Prev button */}
      {!!prevStep && (
        <Button
          size="lg"
          colorScheme="white"
          onClick={(e) => {
            setStep(prevStep);
            e.currentTarget.blur();
          }}
        >
          <svg
            className="prevIcon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.9995 12H4.99951"
              stroke="#333"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.9995 19.0002L4.99951 12.0002L11.9995 5.00024"
              stroke="#333"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <FixFontShift>{t("prev")}</FixFontShift>
        </Button>
      )}

      <Spacer minW={2} />

      {/* Nextbutton */}
      {!!nextStep && (
        <Button
          size="lg"
          colorScheme="blue"
          onClick={(e) => {
            setStep(nextStep);
            e.currentTarget.blur();
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.99951 12H18.9995"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 5L19 12L12 19"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <FixFontShift>{t("next")}</FixFontShift>
        </Button>
      )}
    </Flex>
  );
};

export default StepperActions;
